module.exports = __webpack_public_path__ + "img/weddings_12_V.28fdf3a9.webp";